<template>
  <div class="container">
    <h1 class="main">{{ $t('authorWorksTitle15') }}</h1>
    <div class="image-container">
      <div class="row">
        <div class="image-item long">
          <img :src="img1" alt="Image 1" />
          <p>{{ $t('authorWorkItem16') }}</p>
        </div>
        <div class="image-item short">
          <img :src="img2" alt="Image 2" />
          <p>{{ $t('authorWorkItem17') }}</p>
        </div>
        <div class="image-item long">
          <img :src="img3" alt="Image 3" />
          <p>{{ $t('authorWorkItem18') }}</p>
        </div>
      </div>
      <div class="row">
        <div class="image-item short">
          <img :src="img4" alt="Image 4" />
          <p>{{ $t('authorWorkItem19') }}</p>
        </div>
        <div class="image-item long">
          <img :src="img5" alt="Image 5" />
          <p>{{ $t('authorWorkItem20') }}</p>
        </div>
        <div class="image-item short">
          <img :src="img6" alt="Image 6" />
          <p>{{ $t('authorWorkItem21') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import img1 from "@/assets/images/card1.jpg";
import img2 from "@/assets/images/card2.jpg";
import img3 from "@/assets/images/card3.jpg";
import img4 from "@/assets/images/card4.jpg";
import img5 from "@/assets/images/card5.jpg";
import img6 from "@/assets/images/maqom.jpg";

export default {
  data() {
    return {
      img1,
      img2,
      img3,
      img4,
      img5,
      img6
    };
  }
};
</script>

<style scoped>
.main {
  text-align: center;
  font-weight: 600;
  margin: 40px;
}

.row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.image-item {
  width: 30%;
  text-align: center;
  margin-bottom: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.image-item img {
  width: 100%;
  height: 100%; 
  border-radius: 8px;
  object-fit: cover;
}

.long img {
  height: 300px; 
}

.short img {
  height: 250px;
}

p {
  font-size: 14px;
  margin-top: 10px;
}

@media (max-width: 1024px) {
  .image-item {
    width: 30%; 
  }

  .long img {
    height: 300px; 
  }

  .short img {
    height: 250px; 
  }

  .row {
    justify-content: space-between;
  }
}

@media (max-width: 768px) {
  .image-item {
    width: 48%;
  }

  .long img {
    height: 250px;
  }

  .short img {
    height: 200px; 
  }

  .row {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .main {
    font-size: 1.5rem;
    margin: 20px;
  }

  p {
    font-size: 12px;
  }

  .long img {
    height: 220px; 
  }

  .short img {
    height: 180px;
  }

  .image-item {
    width: 100%;
  }
}

</style>
